import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiMessageCircle, FiAlertTriangle, FiUsers, FiTrendingUp, FiFileText, FiX } = FiIcons;

const navigationItems = [
  { name: 'Dashboard', href: '/', icon: FiHome },
  { name: 'Sentiment Analysis', href: '/sentiment', icon: FiMessageCircle },
  { name: 'Service Gaps', href: '/service-gaps', icon: FiAlertTriangle },
  { name: 'Retention Risk', href: '/retention', icon: FiUsers },
  { name: 'Performance', href: '/performance', icon: FiTrendingUp },
  { name: 'Reports', href: '/reports', icon: FiFileText },
];

const Sidebar = ({ isOpen, setIsOpen }) => {
  const location = useLocation();

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Sidebar */}
      <motion.div 
        initial={false}
        animate={{ x: isOpen ? 0 : -320 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-y-0 left-0 z-50 w-80 bg-white shadow-xl lg:relative lg:translate-x-0 lg:shadow-none"
      >
        <div className="flex items-center justify-between h-16 px-6 border-b border-secondary-200">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center">
              <span className="text-white font-bold text-lg">TN</span>
            </div>
            <div>
              <h1 className="text-xl font-bold text-secondary-900">TrustNation</h1>
              <p className="text-sm text-secondary-500">AI Feedback Platform</p>
            </div>
          </div>
          
          <button 
            onClick={() => setIsOpen(false)}
            className="lg:hidden p-2 rounded-lg hover:bg-secondary-100 transition-colors"
          >
            <SafeIcon icon={FiX} className="w-5 h-5 text-secondary-600" />
          </button>
        </div>

        <nav className="mt-8 px-4">
          <div className="space-y-2">
            {navigationItems.map((item) => {
              const isActive = location.pathname === item.href;
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsOpen(false)}
                  className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 ${
                    isActive 
                      ? 'bg-primary-50 text-primary-700 border-l-4 border-primary-500' 
                      : 'text-secondary-600 hover:bg-secondary-100 hover:text-secondary-900'
                  }`}
                >
                  <SafeIcon 
                    icon={item.icon} 
                    className={`w-5 h-5 mr-3 ${isActive ? 'text-primary-600' : 'text-secondary-500'}`} 
                  />
                  <span className="font-medium">{item.name}</span>
                </Link>
              );
            })}
          </div>
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-4">
          <div className="bg-gradient-to-r from-primary-500 to-primary-600 rounded-xl p-4 text-white">
            <h3 className="font-semibold text-sm mb-2">Upgrade to Pro</h3>
            <p className="text-xs text-primary-100 mb-3">Get advanced analytics and unlimited feedback processing</p>
            <button className="w-full bg-white text-primary-600 py-2 px-4 rounded-lg text-sm font-medium hover:bg-primary-50 transition-colors">
              Upgrade Now
            </button>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Sidebar;